import { Carousel, Slide } from 'vue-carousel';
import gallery from 'vue-gallery';
import { mapGetters } from "vuex";

export default {
    name: 'gallery-product',
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    components: {
        Carousel,
        gallery,
        Slide
    },
    data() {
        return {
            currentSlideMain: 0,
            currentSlideTumble: 0,
            disablePrev: false,
            disableNext: false,
            index: null,
            images: [],
            galleryKey: 0
        }
    },
    computed: {
        ...mapGetters({
            productData: 'card/productData',
        })
    },
    watch: {
        productData: {
            handler(newVal) {
                if (newVal && newVal.images) {
                    this.images = newVal.images.map(el => el.link);
                    this.galleryKey++;
                } else {
                    this.images = [];
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.setClassTumble(this.items);
    },
    methods: {
        changeArrow(value) {
            const carousel = this.$refs['slider-items'];
            const carousel2 = this.$refs['slider-tumble'];
            const currentPage = carousel.currentPage;
            const currentPage2 = carousel2.currentPage;
            const pageCount = carousel.pageCount;
            const pageCount2 = carousel2.pageCount;

            if (value === 'prev') {
                if (currentPage > 0) carousel.goToPage(currentPage - 1);
                if (currentPage2 > 0) carousel2.goToPage(currentPage2 - 1);
            } else {
                if (currentPage < pageCount - 1) carousel.goToPage(currentPage + 1);
                if (currentPage2 < pageCount2) carousel2.goToPage(currentPage2 + 1);
            }
        },
        goToSlide(index) {
            const carousel = this.$refs['slider-items'];
            const carousel2 = this.$refs['slider-tumble'];
            carousel.goToPage(index);
            carousel2.goToPage(index);
        },
        pageChangeMain(slide) {
            this.currentSlideMain = slide;
            this.$refs['slider-tumble'].goToPage(slide);
        },
        pageChangeTumble(slide) {
            this.currentSlideTumble = slide;
            this.$refs['slider-items'].goToPage(slide);
        },
        setClassTumble(items) {
            return `card-gallery__tumble-${items.length}`;
        }
    }
}
